<template>
    <div id="ag-grid-demo">
        <vx-card>

            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">

                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit
                                > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-input id="txt-search" class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery"
                        placeholder="Search..." />
                    <vs-button id="btn-add-user" class="mb-4 md:mb-0 mr-4" icon="add" :to="'/users/add'">Add User
                    </vs-button>
                    <vs-button id="btn-export-csv" class="mb-4 md:mb-0" @click="sendLogExportCsv()">Export as
                        CSV</vs-button>
                </div>
            </div>
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="dataTrx" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limit" :suppressPaginationPanel="true" :enableCellTextSelection="true">
            </ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import { url } from '@/configs/apiUrl'
import Axios from '@/global/AxiosCall';
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import ActionTableViewEditAgGridComponent from '@/components/cell-render-component/ActionTableViewEditAgGridComponent'

export default {
    components: {
        AgGridVue,
    },
    data() {
        return {
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            columnDefs: [
                {
                    headerName: "User ID",
                    field: "id",
                    width: 150,
                    filter: true,
                    pinned: "left"
                },
                {
                    headerName: "User Name",
                    field: "username",
                    width: 250,
                    filter: true,
                },
                {
                    headerName: "Email",
                    field: "email",
                    filter: true,
                    width: 250
                },
                {
                    headerName: "Date Registered",
                    field: "created_at",
                    filter: true,
                    cellRenderer: function (params) {
                        return params.value.replace('T', ' ').replace('.000', '').replace('Z', '')
                    },
                    width: 200
                },
                {
                    headerName: "Actions",
                    field: "id",
                    filter: false,
                    editable: false,
                    cellRendererFramework: ActionTableViewEditAgGridComponent,
                    width: 200
                }
            ],
            dataTrx: [],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 20,
            currentUser: {
                id: 0,
                group: "",
            },
            auditUser: {
                user_id: "",
                session_id: "",
                user_name: "",
                menu: "",
                activity: "",
                data_before: {},
                data_after: {},
            },
            totalData: 1,
        }
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned('Channel', null);
            } else this.gridOptions.columnApi.setColumnPinned('Channel', 'left')
        }
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.fetchData(val, this.limit)
            }
        }
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        fetchData(page, limit) {
            try {
                var userData = JSON.parse(localStorage.getItem("userInfo"))
                this.currentUser.id = userData.id
                var authToken = userData.access_token.token
            }
            catch (e) {
                console.log(e)
            }
            this.openLoading()
            Axios.GetUserFromToken(url.svd.auth.me, { authToken: authToken }).then(response => {
                if (response.data.code == 200) {
                    //todo remove condition
                    if (typeof response.data.data.roles[0] == 'string') {
                        this.currentUser.group = 'aino'
                    } else {
                        this.currentUser.group = response.data.data.roles[0].group
                    }

                    let newPage = page
                    if (this.dataCount != 0) {
                        let totalPages = Math.ceil(this.dataCount / limit)
                        if (page > totalPages) {
                            newPage = totalPages
                        }
                    }
                    Axios.Get(url.svd.user.list + '?page=' + newPage + '&limit=' + limit + "&role_group=" + this.currentUser.group).then(resp => {
                        this.$vs.loading.close()
                        this.dataTrx = []
                        if (resp.data.data.length != 0) {
                            this.totalData = parseInt(resp.data.total)
                            let no = ((page - 1) * limit) + 1
                            for (let data of resp.data.data) {
                                data.no = no
                                data.email = data.email.replace(/^(.)(.*)(.@.*)$/,
                                    (_, a, b, c) => a + b.replace(/./g, '*') + c
                                );
                                this.dataTrx.push(data)
                                no++;
                            }

                            this.dataCount = resp.data.total
                            this.page = page
                            if (limit >= this.dataCount) {
                                this.limit = this.dataTrx.length
                            } else {
                                this.limit = limit
                            }

                            this.gridApi.paginationSetPageSize(this.limit)
                            this.totalPage = resp.data.lastPage
                        }
                    }).catch(e => {
                        this.$vs.loading.close()
                        console.log(e)
                    })
                } else {
                    this.$vs.loading.close()
                    this.danger("Error", "Retrieve user data failed (" + response.message + ")")
                }
            })
        },
        editRecord(value) {
            this.$router.push({
                name: 'UsersEdit',
                params: {
                    id: value
                }
            })
        },
        configureRecord(value) {
            this.$router.push({
                name: 'UsersConfigure',
                params: {
                    id: value
                }
            })
        },
        sendLogExportCsv() {
            this.gridApi.exportDataAsCsv();
            this.$store.dispatch('createAuditTrail', {
                user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                session_id: parseInt(localStorage.getItem('sessID')),
                user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                menu: "User Management",
                activity: "Export Csv",
                data_before: {},
                data_after: {},
            })
        }
    },
    created() {
        Axios.Post(url.svd.auth.validatesession).then(res => {
            this.auditUser = { session_id: res.data.id }
        })
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.gridOptions.rowHeight = 42;

        this.$root.$on("delete-from-ActionTableAgGridComponent", (data) => {
            this.deleteRecord(data)
        })

        this.$root.$on("edit-from-ActionTableAgGridComponent", (data) => {
            this.editRecord(data)
        })

        this.$root.$on("configure-from-ActionTableAgGridComponent", (data) => {
            this.configureRecord(data)
        })


    }
}
</script>